<template>
  <MasterdataTableContainer
    :loading="$apollo.loading"
    :headers="headers"
    :table-data="tableData"
    :pagination="false"
    @row-click="onRowClick"
  >
    <v-menu
      slot="left"
      v-model="dateDialog"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          rounded
          filled
          v-model="dateRangeText"
          dense
          :hide-details="true"
          v-on="on"
          v-bind="attrs"
          readonly
          prepend-inner-icon="mdi-calendar-range"
          class="mr-4"
        ></v-text-field>
      </template>
      <v-date-picker
        first-day-of-week="1"
        v-model="dates"
        range
      ></v-date-picker>
    </v-menu>

    <template v-slot:modal>
      <v-dialog :value="Boolean(selectedDeviation)" width="600" persistent>
        <LinkDeviationCrewModal
          v-if="Boolean(selectedDeviation)"
          :item="selectedDeviation"
          @confirm="onConfirm"
        />
      </v-dialog>
    </template>

    <v-btn
      @click="exportExcel"
      slot="right"
      rounded
      :disabled="!tableData.length"
      :loading="exporting"
    >
      <v-icon left small>mdi-file-export-outline</v-icon>
      Export Excel</v-btn
    >
  </MasterdataTableContainer>
</template>

<script>
import MasterdataTableContainer from '@/modules/masterdata/components/MasterdataTableContainer'
import LinkDeviationCrewModal from './LinkDeviationCrewModal'
import { get } from 'vuex-pathify'
import { format } from 'date-fns'
import orderBy from 'lodash.orderby'
import { exportExcel } from '@/services/exportExcel.service'

export default {
  name: 'LinkDeviationCrewTable',

  components: {
    MasterdataTableContainer,
    LinkDeviationCrewModal
  },

  data() {
    return {
      exporting: false,
      dateDialog: false,
      dates: [
        format(new Date(), 'yyyy-MM-dd'),
        format(new Date(), 'yyyy-MM-dd')
      ],
      headers: [
        {
          text: 'Händelse',
          value: 'crew_deviation.event.title'
        },
        {
          text: 'Tågnr.',
          value: 'train_number'
        },
        {
          text: 'Tjänstedatum',
          value: 'duty_date'
        },
        {
          text: 'Från plats',
          value: 'from'
        },
        {
          text: 'till plats',
          value: 'to'
        }
      ]
    }
  },

  watch: {
    dates: {
      handler: 'onConfirm',
      immediate: true
    }
  },

  computed: {
    selectedDeviation: get('linkDeviation/selectedDeviation'),
    unhandledCrewDeviations: get('linkDeviation/unhandledCrewDeviations'),

    datesSorted() {
      return orderBy(this.dates, [x => x], ['asc'])
    },

    dateRangeText() {
      return this.dates.join(' ~ ')
    },

    tableData() {
      return orderBy(
        this.unhandledCrewDeviations || [],
        ['duty_date'],
        ['desc']
      )
    }
  },

  methods: {
    onConfirm() {
      if (this.datesSorted.length !== 2) return
      const [from, to] = this.datesSorted
      this.$store.dispatch('linkDeviation/fetchUnhandledCrewDeviations', {
        district_id: this.$store.get('app/selectedDistrictId'),
        from,
        to
      })
    },

    onRowClick(item) {
      this.$store.set('linkDeviation/selectedDeviation', item)
    },

    async exportExcel() {
      this.exporting = true

      const pluckKeys = x => {
        return {
          Händelse: x?.crew_deviation?.event?.title,
          'Tågnr.': x.train_number,
          'Tjänstedatum.': x.duty_date,
          'Från plats': x.from,
          'Till plats': x.to
        }
      }

      await exportExcel({
        name: `Bemanningsavvikelser ${this.dateRangeText}`,
        sheets: [
          {
            name: 'Bemanningsavvikelser',
            data: this.tableData.map(pluckKeys)
          }
        ]
      })

      this.exporting = false
    }
  }
}
</script>
